import { DBConnectorService } from './../service/test.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css']
})
export class ManageUserComponent implements OnInit {
  Admin = false;
  tabSelected = 'users';
  RoleId = '';

  onSelect(tab: string) {
    this.tabSelected = tab;
  }
  constructor(private dbconnectorservice: DBConnectorService) {
    this.Admin = this.dbconnectorservice.Admin;
    this.RoleId = this.dbconnectorservice.RoleID;
  }

  ngOnInit() {
  }

}
